"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberInput = void 0;
/* eslint-disable @typescript-eslint/comma-dangle */
const react_1 = __importDefault(require("react"));
const react_hook_form_1 = require("react-hook-form");
const input_1 = require("../../input");
const maybe_unwrap_1 = require("@app/util/apollo/maybe-unwrap");
const util_1 = require("@app/util");
const NumberInput = ({ control, name, label, disabled, integerOnly, rules, ...rest }) => {
    const { field, fieldState } = (0, react_hook_form_1.useController)({ control, name, rules });
    const isNumber = !Number.isNaN(parseInt(field.value));
    return react_1.default.createElement(input_1.Input, { type: 'number', size: "full-width", label: (0, maybe_unwrap_1.unwrapMaybe)(label), disabled: field.disabled || disabled, 
        // @ts-expect-error
        innerRef: field.ref, value: isNumber ? field.value : undefined, onChange: (v) => {
            const numberValue = parseFloat(v);
            if (isNaN(numberValue)) {
                field.onChange(null);
                return;
            }
            field.onChange(numberValue);
        }, onBlur: field.onBlur, name: field.name, ...rest, hasError: (0, util_1.isDefined)(fieldState.error), errorMessage: fieldState.error?.message });
};
exports.NumberInput = NumberInput;
